import React from 'react';
import { Skeleton } from 'primereact/skeleton';

export default function BillingPlaceholder() {
  return (
    <div className="card-bg p-3">
      <div className="row">
        <div className="col-3">
          <Skeleton width="90%" height="80px" borderRadius="8px" />
        </div>
        <div className="col-3">
          <Skeleton width="90%" height="80px" borderRadius="8px" />
        </div>
        <div className="col-3">
          <Skeleton width="90%" height="80px" borderRadius="8px" />
        </div>
        <div className="col-3">
          <Skeleton width="90%" height="80px" borderRadius="8px" />
        </div>
      </div>
    </div>
  );
}
